import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';

const CustomMovementsSectionTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    { key: 'date', content: t('Date') },

    { key: 'code', content: t('Code') },

    { key: 'description', content: t('Description') },
  ] as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default CustomMovementsSectionTableHeader;
